import { Howl } from "howler";

// class AudioSource: a sound that contributes to the aurazliation
// - posX and posY is in utm33
// - decay type: "none", "lin", "log"
// - radius is in meters
// - sound is Howler type
export default class AudioSource {
  public posX: number;
  public posY: number;
  public decay: string;
  public radius: number;
  public sound: Howl;

  // path is path to the sound file in local filesystem
  public constructor(x: number, y: number, d: string, r: number, path: string, loop = true) {
    console.log("Path: " + path);
    this.posX = x;
    this.posY = y;
    this.decay = d;
    this.radius = r;
    this.sound = new Howl({ src: [path], loop, format: ["mp3"] });
  }
}

// promini da ima i linearni pad i rast
